import {_} from 'lodash';
import {IRulesetVariableCrud, viewModel as RulesetVariableCrudViewModel} from '../../../ruleset/variable/crud'

export {template} from '../../../ruleset/variable/crud'

interface IParams extends IRulesetVariableCrud {
    arr: KnockoutObservableArray<KnockoutObservable<number>>
}

export class viewModel extends RulesetVariableCrudViewModel {

    private readonly arr: KnockoutObservableArray<KnockoutObservable<number>>;

    constructor(params: IParams) {
        super(_.defaultsDeep(params, {
            operations: [
                'preview',
                'update',
                'read',
                {name: 'remove', callback: () => this.arr.remove(this.id)}
            ],
        }));
        this.arr = params.arr
    }

}